import React, {  useState, useRef, useEffect} from 'react';
import Layout from 'components/common/DashboardLayout'
import { Link } from '@reach/router';
import GroupPathway from '../groupPathway';
import FeedsChat from '../feedsChat';
import { FaArrowLeft } from 'react-icons/fa';

import OthergrouppathwayFeeds from './othergrouppathwayFeeds';



const OtherGroupIndex = () => {
    // <Link to='/cardsdetails' className={`ccard whiteText ${card.cardColor === 'Yellow'? 'bluebg':'bg-black'} `} onClick={() => {setActive(true)}}></Link>
    var myReminder = localStorage.getItem('memberReminder');
    return (
      <Layout>
        <section className=" feeds-dashboard bg-white">
          <div
            className="isw-container"
            style={{  width: '100%', overflow: 'scroll' }}
          >

<Link to='/feeds' style={{color:'#66A848', fontSize:'16px', marginBottom:'1rem', display:'flex', alignItems:'center', gap:'4px', fontWeight:'700',marginTop:'5px'}}><FaArrowLeft/>Go back</Link>

      {/* <Link to='/feeds'  onClick={() => {}}>
      Back
          </Link> */}

            <div className='d-flex w-full'>
              <div style={{width:'70%'}}>
               
              {/* <GroupPathway/> */}
              <OthergrouppathwayFeeds/>
              </div>
              <div style={{width:'30%'}}>
             
                <FeedsChat/>
                </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  };
  
export default OtherGroupIndex